/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box, Stack, Text } from '@towersystems/towersystems-design-system';
import { map } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestConnectionSalesTypes } from 'state/connection-sales-types/actions';
import usePagination from 'modules/dashboard/pagination/use-pagination';
import SalesTypesListTable from './sales-types-list-table';

const SalesTypesList = ({ connectionSalesTypes, requestingConnectionSalesTypes, connectionId, connectionType, ...props }) => {

    const { currentItems, setCriteria, requestItems, isRequesting, footer } = usePagination(
        connectionSalesTypes
    );

    return (
        <React.Fragment>
            <Stack className='resources__list-wrapper' space='large'>
                <Card>
                    <SalesTypesListTable 
                        requestingConnectionSalesTypes={requestingConnectionSalesTypes} 
                        connectionSalesTypes={connectionSalesTypes} 
                        connectionId={connectionId} /> 
                </Card>
                {footer}
            </Stack>
        </React.Fragment>
        
    );
};

export default connect((state) => ({}), {
})(SalesTypesList);